"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _Link = require("../Link");

var _TagItem = require("./TagItem");

var _excluded = ["tags", "limit", "isLoading"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var TagListWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1t66qkw1"
} : {
  target: "e1t66qkw1",
  label: "TagListWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "v0a937",
  styles: "display:flex;flex-wrap:wrap;>*{margin-right:10px;margin-bottom:10px;}margin-bottom:-10px"
} : {
  name: "v0a937",
  styles: "display:flex;flex-wrap:wrap;>*{margin-right:10px;margin-bottom:10px;}margin-bottom:-10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var MoreTagsButton = ( /*#__PURE__*/0, _theming.styled)(_Link.Link, process.env.NODE_ENV === "production" ? {
  target: "e1t66qkw0"
} : {
  target: "e1t66qkw0",
  label: "MoreTagsButton"
})("color:", _styles.color.mediumdark, ";font-size:", _styles.typography.size.s2, "px;font-weight:", _styles.typography.weight.bold, ";padding-left:5px;padding-right:5px;&:focus{outline:auto;}");
var TagList = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$tags = _ref.tags,
      tags = _ref$tags === void 0 ? [] : _ref$tags,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 4 : _ref$limit,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var primaryTags = tags.slice(0, limit);
  var moreTags = tags.slice(limit);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      moreTagsVisible = _useState2[0],
      setMoreTagsVisible = _useState2[1];

  var tagContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, primaryTags, moreTagsVisible && moreTags, moreTags.length > 0 && !moreTagsVisible && /*#__PURE__*/_react["default"].createElement(MoreTagsButton, {
    isButton: true,
    appearance: "primary",
    onClick: function onClick() {
      return setMoreTagsVisible(true);
    }
  }, "+ ".concat(moreTags.length, " more")));

  return /*#__PURE__*/_react["default"].createElement(TagListWrapper, (0, _extends2["default"])({}, props, {
    ref: ref
  }), isLoading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TagItem.TagItem, {
    isLoading: true
  }), /*#__PURE__*/_react["default"].createElement(_TagItem.TagItem, {
    isLoading: true
  }), /*#__PURE__*/_react["default"].createElement(_TagItem.TagItem, {
    isLoading: true
  }), /*#__PURE__*/_react["default"].createElement(_TagItem.TagItem, {
    isLoading: true
  })) : tagContent);
});
exports.TagList = TagList;